import React, { useState } from 'react';
import { YearByYearCommon } from './../browse/YearByYearCommon';
import { Header, Divider, Icon } from 'semantic-ui-react'

export function PersonCalendar(props) {
	const [childRendering, setChildRendering] = useState(true);
	return (
		<>
			{childRendering &&
				<>
					<Divider horizontal inverted>
						<Header as='h4' inverted>
							<Icon name='calendar alternate outline' />
							Calendar
						</Header>
					</Divider>
					<YearByYearCommon slim={true} person={props.person}
						urlParams={false} relatedRendered={(val) => setChildRendering(val)}/>
				</>
			}
		</>
	);
}